import { useEffect, useRef, useState } from 'react';
import { Link } from 'react-router-dom';
import homeInfo from '../../Content/Data/Home/home.json';
import navigationJson from '../../Content/Data/Navigation/navigation.json';
import servicesInfo from '../../Content/Data/Services/Info/info.json';
import contactUsJson from '../../Content/Data/ContactUs/contactUs.json';

function Home(props) {

    const navigation = useRef(navigationJson.find(x => x.name.toLowerCase() === "services").subMenu);
    const [images, setImages] = useState(null);

    useEffect(() => {
        loadData();
    }, [props.isPathChanged]);

    const loadData = async () => {
        try {
            let imageData = {};
            for (let i = 0; i < homeInfo["Images"].length; i++) {
                const imgData = await import(`../../Content/Images/${homeInfo["Images"][i]["ImgName"]}`);
                imageData = {
                    ...imageData,
                    [homeInfo["Images"][i]["ImgKey"]]: imgData.default
                };
            }
            setImages(Object.keys(imageData).length ? imageData : false);
        } catch (error) {
            console.error("Failed to load images:", error);
        }
    };

    function getClassNames(item) {
        let classNames = "";
        if (item.IsSubTree) {
            classNames += "home-sub-tree";
        }
        if (item.Type === "table") {
            classNames += "home-table";
        }
        if (item.ClassNames && item.ClassNames.length > 0) {
            item.ClassNames.map(x => {
                classNames += x + " ";
            })
        }
        return classNames.trim();
    }

    function getText(item, index) {
        let content = item.Content + " ";
        if (content.includes("{amatya-email}")) {
            content = content.replaceAll("{amatya-email}", "'" + contactUsJson.email + "'")
        }
        if (item.Links && item.Links.length > 0) {
            item.Links.map(x => {
                let link;
                if (x.Type === "text anchor") {
                    link = `<a href=${x.Url} target='_blank'>${x.Text}</a>`;
                }
                else if (x.Type === "button anchor") {
                    link = `<a href=${x.Url} target='_blank'><button>${x.Text}</button></a>`;
                }
                content = content.replaceAll(x.ReplaceText, link);
            });
        }
        return (
            <div key={index} className={getClassNames(item)} dangerouslySetInnerHTML={{ __html: content }} />
        );
    }

    function getImage(item, index) {
        return item.ImageKey && images && (
            <div key={index} className={getClassNames(item) + "-container"}>
                <div className={getClassNames(item) + '-img-container'}>
                    <img src={images[item.ImageKey]} className={getClassNames(item) + '-img'} alt={item.AltText} />
                </div>
                <div key={index} className={getClassNames(item) + '-description-container'} dangerouslySetInnerHTML={{ __html: item.Description }} />
            </div>
        );
    }

    function getContent(item, index) {
        return (
            item.Type.toLowerCase() === "image" ?
                getImage(item, index)
                :
                getText(item, index)
        );
    }

    return (
        <div className="home">
            <div className="home-container">
                {
                    homeInfo.Sections.map((section, i) => {
                        return (
                            <div key={i} className={getClassNames(section)}>
                                {
                                    section.Data.map((x, j) => {
                                        return getContent(x, j)
                                    })
                                }
                                {
                                    section.SectionName.toLowerCase() === "services" &&
                                    <div className='home-services-list'>
                                        {
                                            servicesInfo.map((x, i) => {
                                                let nav, subNav = null;
                                                nav = navigation.current.find(y => y.name === x.ServiceName);
                                                if (!nav) {
                                                    nav = navigation.current.find(y => y.name === x.SubPartOf);
                                                    subNav = nav.subMenu.find(y => y.name === x.ServiceName);
                                                }
                                                return (
                                                    <div key={i} className="home-services-item">
                                                        <div className='home-services-item-images'>
                                                            {x.ImageKey && images && <img src={images[x.ImageKey]} alt={x.ServiceName} style={{ height: "inherit", width: "inherit" }} />}
                                                        </div>
                                                        <div className="home-services-item-heading">
                                                            <div className='home-services-item-read-more-link'>
                                                                <Link to={subNav ? `/services?a=${nav.to}&b=${subNav.to}` : `/services?a=${nav.to}`}>
                                                                    {x.ServiceName}
                                                                </Link>
                                                            </div>
                                                        </div>
                                                        <div className="home-services-item-description">
                                                            {x.ServiceDescription}
                                                        </div>
                                                    </div>
                                                );
                                            })
                                        }
                                    </div>
                                }
                            </div>
                        )
                    })
                }
            </div>
        </div>
    );
}

export default Home;
